import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

function ResaleTicketsBannerButton({
    onResaleClick,
    buttonText,
    buttonColor
}) {
    return (
        <Fragment>
            <button
                className={`hero-banner-homepage-enhanced__button button button--${buttonColor} button--icon button--play`}
                onClick={onResaleClick}
            >{buttonText}
            </button>
        </Fragment>
    );
}

ResaleTicketsBannerButton.propTypes = {
    onResaleClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonColor: PropTypes.string.isRequired,
};

export default ResaleTicketsBannerButton;
